import React from 'react'

interface Props {
  size?: number
  className?: string
}

export const ZapierIcon: React.FC<Props> = ({ size = 18, className }) => (
  <img
    src='/media/tfi/zapier-24.png'
    alt='Zapier'
    className={className}
    style={{ width: size, height: size, objectFit: 'contain' }}
  />
)
